import { render, staticRenderFns } from "./registrationConfiguration.vue?vue&type=template&id=167b11fa&scoped=true"
import script from "./registrationConfiguration.vue?vue&type=script&lang=js"
export * from "./registrationConfiguration.vue?vue&type=script&lang=js"
import style0 from "./registrationConfiguration.vue?vue&type=style&index=0&id=167b11fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b11fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167b11fa')) {
      api.createRecord('167b11fa', component.options)
    } else {
      api.reload('167b11fa', component.options)
    }
    module.hot.accept("./registrationConfiguration.vue?vue&type=template&id=167b11fa&scoped=true", function () {
      api.rerender('167b11fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/signLimitConfiguration/component/registrationConfiguration.vue"
export default component.exports